import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidebarService {

  private _open = signal(true);
  private _collapsed = signal(false);

  open = this._open.asReadonly();
  collapsed = this._collapsed.asReadonly();

  /* =====================================================
     HELPERS
     ===================================================== */
  private isMobile(): boolean {
    return window.innerWidth <= 1024;
  }

  /* =====================================================
     OPEN / CLOSE
     ===================================================== */
  toggleOpen() {
    this._open.update(v => !v);

    // 🚫 en móvil NO usamos collapsed
    if (this.isMobile()) {
      this._collapsed.set(false);
    }
  }

  openSidebar() {
    this._open.set(true);

    if (this.isMobile()) {
      this._collapsed.set(false);
    }
  }

  closeSidebar() {
    this._open.set(false);
  }

  /* =====================================================
     COLLAPSE (SOLO DESKTOP)
     ===================================================== */
  toggleCollapsed() {
    if (this.isMobile()) return; 
    this._collapsed.update(v => !v);
  }

  setCollapsed(v: boolean) {
    if (this.isMobile()) return;
    this._collapsed.set(v);
  }

  /* =====================================================
     MOBILE UX
     ===================================================== */
  closeOnMobile() {
    if (this.isMobile()) {
      this._open.set(false);
    }
  }
}
